// extracted by mini-css-extract-plugin
export default {"container":"Requirements_container__QCtz9","text":"Requirements_text__5VXAU"};